import { Component } from '@felicity/vision';
import ProfileManager from '../ui/ProfileManager.mjs';

/**
 * Users screen
 */
export default class Users extends Component {
  /**
   * Provides access to the profile manager
   * @type {ProfileManager}
   */
  get profileManager() {
    return this.#manager;
  }

  /** @type {ProfileManager} */
  #manager;

  constructor() {
    super();

    this.#manager = new ProfileManager();
    this.profileManager.crudUri = '/api/Users/Profile';
  }

  _prepare() {
    super._prepare();
    this.classList.add('screen');

    this.appendChild(this.profileManager);
    this.profileManager.grid.height = '100%';
    this.profileManager.grid.width = '100%';
  }
}
